var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{staticClass:"select_button",on:{"click":_vm.handleClickSelectButton}},[_c('i',{staticClass:"fas fa-arrows-alt"})]),_c('video',{ref:"media",class:{
      reversal: _vm.participant.isLocal,
      video_contents_muted: !_vm.screenActive
    },attrs:{"playsinline":"","autoplay":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }